var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mtoc-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.statusChange.apply(null, arguments)}}},[_c('div',{staticClass:"mtoc-main"},_vm._l((3),function(item,index){return _c('span',{key:index,staticClass:"mtoc-item",class:{'status-close': _vm.status, 'status-fixed': _vm.headerFixed}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cef5f362","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menuToClose/mtoc.vue
// module id = null
// module chunks = 